function dateInputValue(date) {
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`
}

export function defaultHearingFilters(today = new Date()) {
  const end = new Date(today)
  end.setDate(end.getDate() + 90)
  return {
    dataInicio: dateInputValue(today),
    dataFim: dateInputValue(end),
    advogado: '',
    estado: '',
    area: '',
    numeroProcesso: '',
  }
}

export function normalizeHearingFilters(filters) {
  return Object.fromEntries(Object.entries(filters).map(([key, value]) => [key, value.trim()]))
}

function dateTimestamp(value) {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(value || '')) return NaN
  const timestamp = Date.parse(value)
  return Number.isFinite(timestamp) && new Date(timestamp).toISOString().slice(0, 10) === value ? timestamp : NaN
}

export function hearingPeriodError({ dataInicio, dataFim }) {
  const days = (dateTimestamp(dataFim) - dateTimestamp(dataInicio)) / 86400000
  return !Number.isFinite(days) || days < 0 || days > 365
    ? 'Informe um período válido de até 366 dias, com a data final igual ou posterior à inicial.'
    : ''
}
